import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import CategoryName from './CategoryName';
import {MAX_CATEGORY_NAME_LENGTH} from '../../../constants';
import EntityTable from '../../../reusable/LightTable/specific/EntityTable';

export default class CategoryForm extends Component {

    static propTypes = {
        onChange: PropTypes.func,
        values: PropTypes.object,
        setValidationState: PropTypes.func,
        showErrors: PropTypes.bool,
        categoryId: PropTypes.string
    };

    static defaultProps = {
        values: {
            name: '',
            entityIds: []
        },
        showErrors: false,
        categoryId: null
    };

    constructor(props) {
        super(props);

        this.state = {
            errorState: { name: false, entities: false },
            values: { name: props.values.name, entityIds: props.values.entityIds },
            pendingRequestSpinner: false
        };
        this.onEntitiesChange = this.onEntitiesChange.bind(this);
        this.checkFormValidation = this.checkFormValidation.bind(this);
        this.onNameChange = this.onNameChange.bind(this);
    }

    checkFormValidation() {
        if (this.state.values.name && this.state.values.name.length && this.state.values.entityIds.length) {
            this.props.setValidationState(true);
            this.props.onChange(this.state.values);
        } else {
            this.props.setValidationState(false);
            this.props.onChange(this.state.values);
        }
    }

    onNameChange(value) {
        let values = this.state.values;
        values.name = value;
        this.setState({ values }, this.checkFormValidation);
    }

    onEntitiesChange(value) {
        let values = this.state.values;
        values.entityIds = value;
        this.setState({ values }, this.checkFormValidation);
    }

    render() {
        return (
            <div className='create-category-page__form'>
                <CategoryName initialValue={this.props.values.name}
                              categoryId={this.props.categoryId}
                              onChange={this.onNameChange}
                              maxLength={MAX_CATEGORY_NAME_LENGTH}/>

                <div className='entities-title'>
                    <FormattedMessage id='Category_Create_UIText_addCategory.entities' /> <span className='required-field-star' />
                </div>
                <div className='entities-subtitle'><FormattedMessage
                    id='Category_Create_UIText_addCategory.entities.subtitle' /></div>

                {this.props.showErrors && (!this.state.entityIds || this.state.entityIds.length === 0) && (
                    <div className="error-message">
                        <FormattedMessage id={"Category_Create_UIText_addCategory.entities.error"}/>
                    </div>
                )}
                <EntityTable onChange={this.onEntitiesChange} entityIds={this.props.values.entityIds}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/scripts/pages/Categories/Components/CategoryForm.jsx